import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Container } from "react-bootstrap";
import { AuthProvider, useAuth } from "./context/AuthContext";

import UsersList from "./components/users/UsersList";
import CommentsList from "./components/comments/CommentsList";
// Composants d'authentification
import Login from "./components/auth/LoginForm";
import Register from "./components/auth/RegisterForm.js";
import AdminDash from "./components/auth/AdminProfil/AdminDash";
import AdminInfoPage from "./components/auth/AdminProfil/AdminProfil";

// Pages principales
import DictionaryList from "./components/dictionary/DictionaryList";
import DictionaryForm from "./components/dictionary/DictionaryForm";
import DictionnairePage from "./components/dictionary/DictionnairePage";
import DictionaryAdminList from "./components/dictionary/DictionaireAdminList.jsx";
import UserProfile from "./components/auth/userProfile/UserProfile";
import Sidebar from "./components/layout/Sidebar";
import Header from "./components/layout/Header";
import Home from "./components/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import ProjetForm from "./components/project/ProjetForm";
import ProjectList from "./components/project/ProjectList";
import ProjectAdminList from "./components/project/ProjectAdminList";
import ProjectPage from "./components/project/ProjectPage";
import MesContrib from "./components/auth/userProfile/MesContrib";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <div>Chargement...</div>;
  return currentUser ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <div>Chargement...</div>;
  return currentUser && currentUser.profile.role === "admin" ? (
    children
  ) : (
    <Navigate to="/login" />
  );
};

// Route qui redirige les utilisateurs déjà connectés
const AuthRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <div>Chargement...</div>;
  return currentUser ? <Navigate to="/" /> : children;
};
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <div className="d-flex">
          <Sidebar />
          <div
            className="flex-grow-1"
            style={{
              // marginLeft: "240px",
              minHeight: "100vh",
              background: "#e9ecf4",
              minWidth: 0,
            }}
          >
            <Header />
            <Container className="py-4">
              <Routes>
                {/* Routes publiques */}
                <Route
                  path="/login"
                  element={
                    <AuthRoute>
                      <Login />
                    </AuthRoute>
                  }
                />
                <Route
                  path="/register"
                  element={
                    <AuthRoute>
                      <Register />
                    </AuthRoute>
                  }
                />

                {/* Page admin */}
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminDash />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/profil"
                  element={
                    <AdminRoute>
                      <AdminInfoPage />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/projects"
                  element={
                    <AdminRoute>
                      <ProjectAdminList />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/dictionary"
                  element={
                    <AdminRoute>
                      <DictionaryAdminList />
                    </AdminRoute>
                  }
                />
                <Route path="/" element={<Home />} />
                {/* Routes privées */}
                <Route path="/dictionary" element={<DictionaryList />} />
                <Route
                  path="/admin/comments"
                  element={
                    <AdminRoute>
                      <CommentsList />
                    </AdminRoute>
                  }
                />
                <Route path="/dictionary/:id" element={<DictionnairePage />} />
                <Route
                  path="/dictionary/add"
                  element={
                    <PrivateRoute>
                      <DictionaryForm />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dictionary/:id/edit"
                  element={
                    <PrivateRoute>
                      <DictionaryForm />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/projects/new"
                  element={
                    <PrivateRoute>
                      <ProjetForm />
                    </PrivateRoute>
                  }
                />
                {/* <Route path="/admin/dashboard" element={
                <PrivateRoute>
                <AdminDash />
                </PrivateRoute>
                } /> */}
                {/* Projet : édition */}
                <Route
                  path="/projects/:id/edit"
                  element={
                    <PrivateRoute>
                      <ProjetForm />
                    </PrivateRoute>
                  }
                />
                <Route path="/projects" element={<ProjectList />} />
                <Route path="/projects/:id" element={<ProjectPage />} />
                <Route
                  path="/admin/users"
                  element={
                    <AdminRoute>
                      <UsersList />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/profil"
                  element={
                    <PrivateRoute>
                      <UserProfile />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/mes-contributions"
                  element={
                    <PrivateRoute>
                      <MesContrib />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/historique"
                  element={
                    <PrivateRoute>
                      <Container className="my-5">
                        <h1>Historique d'Activité</h1>
                        <p>
                          Cette fonctionnalité est en cours de développement.
                        </p>
                      </Container>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/confidentialite"
                  element={
                    <PrivateRoute>
                      <Container className="my-5">
                        <h1>Paramètres de Confidentialité</h1>
                        <p>
                          Cette fonctionnalité est en cours de développement.
                        </p>
                      </Container>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/notifications"
                  element={
                    <PrivateRoute>
                      <Container className="my-5">
                        <h1>Paramètres de Notifications</h1>
                        <p>
                          Cette fonctionnalité est en cours de développement.
                        </p>
                      </Container>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/aide"
                  element={
                    <PrivateRoute>
                      <Container className="my-5">
                        <h1>Centre d'Aide</h1>
                        <p>
                          Cette fonctionnalité est en cours de développement.
                        </p>
                      </Container>
                    </PrivateRoute>
                  }
                />
                <Route path="/accueil" element={<Navigate to="/" />} />

                {/* Redirection par défaut */}
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Container>
          </div>
        </div>
        {/* Notez que nous avons retiré le NavBar et Container ici pour permettre au Home d'occuper tout l'espace */}
        {/* <AppRoutes /> */}
      </AuthProvider>
    </Router>
  );
}
export default App;
